import { useState } from 'react';
import toaster from 'utils/toaster';
import aiContextService, { CONFLICT_ERROR } from '../service';
import { TOAST_CONFIG } from '../constants';

const TOASTS_PREFIX = 'STATIC.PAGES.AI_CONTEXT.TOASTS';

const useConflictResolution = ({ answers, setAnswers, applySavedVersion, translate }) => {
    const [conflict, setConflict] = useState(null);
    const [isResolvingConflict, setIsResolvingConflict] = useState(false);

    const cancelConflict = () => {
        setConflict(null);
        setIsResolvingConflict(false);
    };

    const resolveConflict = (resolvedAnswers, latestVersionId) => {
        const mergedAnswers = { ...answers, ...resolvedAnswers };
        setAnswers(mergedAnswers);
        setIsResolvingConflict(true);
        aiContextService
            .saveAnswers(mergedAnswers, latestVersionId)
            .then(result => {
                applySavedVersion(result);
                setConflict(null);
                toaster.success(translate(`${TOASTS_PREFIX}.SAVE_SUCCESS`), TOAST_CONFIG);
            })
            .catch(err => {
                if (err?.type === CONFLICT_ERROR) {
                    // Another save landed between resolve and re-save — show fresh conflict.
                    setConflict(err);
                    return;
                }
                const message = err?.value || translate(`${TOASTS_PREFIX}.SAVE_FAILED`);
                toaster.error(message, TOAST_CONFIG);
            })
            .finally(() => setIsResolvingConflict(false));
    };

    return {
        conflict,
        isResolvingConflict,
        setConflict,
        cancelConflict,
        resolveConflict,
    };
};

export default useConflictResolution;
